import {
  DateTimeFormatter,
  LocalDateTime,
  ZonedDateTime,
  ZoneId,
} from '@js-joda/core';

/**
 * See https://github.com/marmelab/react-admin/issues/10375
 * and https://github.com/marmelab/react-admin/blob/a70b0dfe99c5a5e6c3a4c610916060752c64704e/packages/ra-ui-materialui/src/input/DateTimeInput.tsx#L207
 *
 * This code is to convert from db UTC timestamps to something <input type="datetime-local">
 * without RA calling new Date() and applying the browser's timezone.
 */
const dateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/; // yyyy-MM-ddThh:mm
const formatter = DateTimeFormatter.ofPattern("yyyy-MM-dd'T'HH:mm");

export const formatUtcDateTimeInput = (v: string) => {
  if (!v) {
    return null;
  }
  if (dateTimeRegex.test(v)) {
    return v;
  }
  return ZonedDateTime.parse(v).format(formatter);
};

export const parseUtcDateTimeInput = (v: string) =>
  v ? LocalDateTime.parse(v).atZone(ZoneId.UTC).toString() : null;

export const parseZonedDateTime = (
  value?: string | null,
): ZonedDateTime | null => {
  if (!value) {
    return null;
  }
  try {
    return ZonedDateTime.parse(value);
  } catch {
    return null;
  }
};

/** Validator factory: the end date must be strictly after the `startSource` date. */
export const endAfter =
  (startSource: string) =>
  (
    value: string,
    allValues: Record<string, string | null | undefined>,
  ): string | undefined => {
    const start = parseZonedDateTime(allValues?.[startSource]);
    const end = parseZonedDateTime(value);
    if (start && end && end.toEpochSecond() <= start.toEpochSecond()) {
      return 'End date must be after the start date';
    }
    return undefined;
  };
